module.exports = __webpack_public_path__ + "static/media/Applis.9bed2c29.png";